<!-- This is showing top slider in home page -->
<ngb-carousel
  *ngIf="carouselService.carousels?.length > 0"
  [showNavigationArrows]="carouselService.carousels?.length > 1"
  [showNavigationIndicators]="carouselService.carousels?.length > 1"
  role="region"
  aria-label="Image Carousel"
>
  <ng-container *ngFor="let carousel of carouselService.carousels; let i = index">
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper" [id]="'ngb-slide-' + i">
        <picture>
          <source
            [srcset]="carousel.image.svg"
            type="image/svg+xml"
            style="width: 100%"
            alt="algoleague"
            height="570"
            width="1650"
          />
          <img
            [src]="carousel.image.normal"
            class="embed-responsive img"
            style="width: 100%;height: auto;"
            [alt]="carousel.title ? (carousel.title | abpLocalization) : 'algoleague'"
            height="570"
            width="1650"
          />
        </picture>
      </div>
      <ng-container *ngIf="!carousel.redirectTo">
        <div class="carousel-caption">
          <!-- <h3 *ngIf="carousel.title">{{ carousel.title | abpLocalization }}</h3> -->
          <p *ngIf="carousel.description">{{ carousel.description | abpLocalization }}</p>
        </div>
      </ng-container>
      <ng-container *ngIf="carousel.redirectTo">
        <div class="carousel-caption cursor-pointer" [routerLink]="carousel.redirectTo">
          <!-- <h3 *ngIf="carousel.title">{{ carousel.title | abpLocalization }}</h3> -->
          <p *ngIf="carousel.description">{{ carousel.description | abpLocalization }}</p>
        </div>
      </ng-container>
    </ng-template>
  </ng-container>
</ngb-carousel>
